var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:[_vm.theme]},[_c('BeatLoader',{attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }